import { Link } from "react-router-dom";
import { ArrowUpRight, CalendarDays, MapPin } from "lucide-react";
import { inr } from "@/lib/api";

export function TripCard({ trip, dark = false }) {
  const dates = Array.isArray(trip?.dates) ? trip.dates : [];
  const georgia = trip?.destination === "Georgia";
  return (
    <Link to={`/trips/${trip.slug}`} data-testid={`trip-card-${trip.slug}`} className="group block">
      <div className={`relative aspect-[4/5] overflow-hidden ${georgia ? "arch" : "rounded-[26px]"}`}>
        <img src={trip.image} alt={trip.title} loading="lazy"
          className={`h-full w-full object-cover ${georgia ? "object-[50%_25%]" : ""} transition-transform duration-[1.2s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.07]`} />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/75 via-ink/5 to-transparent" />
        <div className={`absolute top-4 left-4 right-4 flex items-start ${georgia ? "justify-center" : "justify-between"}`}>
          {trip.badge ? (
            <span className={`eyebrow rounded-full px-3 py-1.5 ${georgia ? "bg-gold text-ink" : "bg-paper/90 text-ink"} ${georgia ? "mt-12 sm:mt-14" : ""}`}>{trip.badge}</span>
          ) : <span />}
        </div>
        <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between text-cream">
          <div>
            {trip.original_price > trip.price && <p className="font-mono text-xs line-through text-cream/70">{inr(trip.original_price)}</p>}
            <p className="font-display text-2xl font-extrabold leading-none" data-testid={`trip-card-price-${trip.slug}`}>
              {inr(trip.price)} <span className="font-body text-xs font-medium text-cream/80">onwards</span>
            </p>
          </div>
          <span className="grid place-items-center h-11 w-11 rounded-full bg-paper text-ink transition-[transform,background-color] duration-500 group-hover:rotate-45 group-hover:bg-terra group-hover:text-paper">
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </div>
      </div>
      <div className="pt-4 space-y-2">
        <p className={`eyebrow ${dark ? "text-gold" : "text-terra"}`}>{trip.nights}N / {trip.days}D · {trip.destination}</p>
        <h3 className={`font-display text-xl font-bold leading-snug tracking-tight line-clamp-2 ${dark ? "text-cream" : "text-ink"}`}>{trip.title}</h3>
        <p className={`flex items-center gap-1.5 text-sm ${dark ? "text-cream/70" : "text-stone-600"}`}>
          <MapPin className="h-3.5 w-3.5 shrink-0" />
          <span className="truncate">{trip.start_location} – {trip.end_location}</span>
        </p>
        {dates.length > 0 && (
          <p className={`flex items-center gap-1.5 text-sm font-mono ${dark ? "text-cream/70" : "text-stone-600"}`}>
            <CalendarDays className="h-3.5 w-3.5 shrink-0" />
            {dates.slice(0, 2).map((d) => d.replace(/ \d{4}$/, "")).join(", ")}
            {dates.length > 2 && <span className="text-terra-soft">+{dates.length - 2} batch</span>}
          </p>
        )}
      </div>
    </Link>
  );
}
